import { render } from "./pwa-install-prompt.vue?vue&type=template&id=d9f4aeb4&scoped=true"
import script from "./pwa-install-prompt.vue?vue&type=script&lang=js"
export * from "./pwa-install-prompt.vue?vue&type=script&lang=js"

import "./pwa-install-prompt.vue?vue&type=style&index=0&id=d9f4aeb4&scoped=true&lang=css"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9f4aeb4"]])

export default __exports__